
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { MaShipcaseService } from '../../../service/mashipcase/mashipcase.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { NumberFloatingFilterComp } from '../../../../../libs/ag-grid/dist/lib/filter/floatingFilter';

@Component({
  selector: 'wa9216',
  templateUrl: 'wa9216.component.html',
  styleUrls: ['wa9216.component.scss']
})
export class Wa9216Component implements OnInit {
  public componentTitle = 'WA9216:出荷ケースマスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public maShipcaseId: number;
  public shipcaseCd: string;
  public shipcaseTx: FormControl;
  public lengthNr: FormControl;
  public widthNr: FormControl;
  public heightNr: FormControl;
  public capacityrateNr: FormControl;
  public updcounterNr: number;
  public selectedOwnerId; // build FormGroup

  private maShipcase:any = null;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private ownerIdCls = '';
  private shipcaseCdCls = '';
  private shipcaseTxCls = '';
  private lengthNrCls = '';
  private widthNrCls = '';
  private heightNrCls = '';
  private capacityrateNrCls = ''

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private maShipcaseService: MaShipcaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    this.shipcaseTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.shipcaseTx.maxLength)]);
    this.lengthNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseLengthNr.maxNr),
      Validators.min(validation.shipcaseLengthNr.minNr)]);
    this.widthNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseWidthNr.maxNr),
      Validators.min(validation.shipcaseWidthNr.minNr)]);
    this.heightNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseHeightNr.maxNr),
      Validators.min(validation.shipcaseHeightNr.minNr)]);
    this.capacityrateNr = new FormControl(100, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.shipcaseCapacityRateNr.maxNr),
      Validators.min(validation.shipcaseCapacityRateNr.minNr)]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() { }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let shipcaseTx = this.shipcaseTx.value.trim();
    let capacityrateNr = this.capacityrateNr.value / 100;
    
    let errors = false;
    if (this.shipcaseTx.errors !== null) {
      this.shipcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lengthNr.errors !== null) {
      this.lengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.capacityrateNr.errors !== null) {
      this.capacityrateNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.maShipcaseService
      .put(
        this.maShipcaseId,
        this.ownerId,
        this.shipcaseCd,
        shipcaseTx, 
        this.lengthNr.value,
        this.widthNr.value,
        this.heightNr.value,
        capacityrateNr,
        'wa9216',
        this.updcounterNr,
        )
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '修正が完了しました');
        }
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const selectedMaShipcase: object = JSON.parse(sessionStorage.getItem('rowCase'));
    this.maShipcase = selectedMaShipcase;

    this.maShipcaseId = selectedMaShipcase['maShipcaseId'];
    this.ownerId =selectedMaShipcase['ownerId'];
    this.ownerCd = selectedMaShipcase['ownerCd'];
    this.ownerTx = selectedMaShipcase['ownerTx'];
    this.shipcaseCd = selectedMaShipcase['shipcaseCd'];
    this.shipcaseTx.setValue(selectedMaShipcase['shipcaseTx']);
    this.lengthNr.setValue(selectedMaShipcase['lengthNr']);
    this.widthNr.setValue(selectedMaShipcase['widthNr']);
    this.lengthNr.setValue(selectedMaShipcase['lengthNr']);
    this.heightNr.setValue(selectedMaShipcase['heightNr']);
    this.capacityrateNr.setValue(selectedMaShipcase['capacityrateNr']);
    this.updcounterNr = selectedMaShipcase['updcounterNr'];

    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.shipcaseTxCls = this.shipcaseTx.value === this.maShipcase['shipcaseTx'] ? '' : (this.shipcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.lengthNrCls = this.lengthNr.value === this.maShipcase['lengthNr'] ? '' : (this.lengthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.widthNrCls = this.widthNr.value === this.maShipcase['widthNr'] ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.heightNrCls = this.heightNr.value === this.maShipcase['heightNr'] ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.capacityrateNrCls = this.capacityrateNr.value === this.maShipcase['capacityrateNr'] ? '' : (this.capacityrateNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);

    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.shipcaseTxCls !== this.STRINGS_ERROR &&
      this.lengthNrCls !== this.STRINGS_ERROR &&
      this.widthNrCls !== this.STRINGS_ERROR &&
      this.heightNrCls !== this.STRINGS_ERROR &&
      this.capacityrateNrCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.shipcaseTxCls === this.STRINGS_ACTIVE ||
        this.lengthNrCls === this.STRINGS_ACTIVE ||
        this.widthNrCls === this.STRINGS_ACTIVE ||
        this.heightNrCls === this.STRINGS_ACTIVE ||
        this.capacityrateNrCls === this.STRINGS_ACTIVE
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9216/wa9216.component.ts